// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"pc_privacyPolicy__GWDTS","not-margin":"pc_not-margin__mEINK","not-sort":"pc_not-sort__H0Po3","privacyPolicyContent":"pc_privacyPolicyContent__saiul"};